<ng-template #loginModel>
  <section [@popOverState]="statusName" class="lm-card" dir="rtl" aria-describedby="login-modal-description">

      <!-- close -->
      <button type="button" class="lm-close" (click)="closeLoginModal()" aria-label="סגירת חלון ההתחברות">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>

      <!-- ── STEP 1 : Phone ── -->
      @if (!otpSent) {
        <div class="lm-progress" aria-label="שלב 1 מתוך 2">
          <span class="lm-progress-label">שלב 1 מתוך 2</span>
          <span class="lm-progress-track" aria-hidden="true"><span></span></span>
        </div>
        <!-- logo mark -->
        <div class="lm-logomark">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
        </div>
        <p class="lm-eyebrow">כניסה מהירה ובטוחה</p>
        <h2 id="login-modal-title" class="lm-h">כניסה או הרשמה ל-Sale4All</h2>
        <p id="login-modal-description" class="lm-p">מספר הטלפון מאפשר לנו לזהות אתכם בבטחה — בלי לזכור סיסמה</p>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <label class="lm-label" for="login-phone">מספר טלפון נייד</label>
          <div class="lm-field" [class.lm-field--focus]="phoneFocus">
            <div class="lm-field-inner">
              <select class="lm-select" aria-label="קידומת מדינה" formControlName="countryCode"
                (focus)="phoneFocus=true" (blur)="phoneFocus=false">
                @for (c of countries; track c) {
                  <option [value]="c.dial_code">
                    {{ c.flag }} {{ c.dial_code }}
                  </option>
                }
              </select>
              <span class="lm-divider-v"></span>
              <input
                id="login-phone"
                class="lm-input"
                type="tel"
                formControlName="phoneNumber"
                appPhoneFormat
                placeholder="050-000-0000"
                dir="ltr"
                autocomplete="tel"
                aria-label="מספר טלפון"
                (focus)="phoneFocus=true"
                (blur)="phoneFocus=false"
                />
            </div>
          </div>
          <button
            class="lm-btn"
            type="button"
            [disabled]="loginForm.get('phoneNumber')?.invalid || sending"
            (click)="sendOtp()"
            >
            שלחו לי קוד כניסה
          </button>
          @if (loginForm.get('phoneNumber')?.touched && loginForm.get('phoneNumber')?.invalid) {
            <p class="lm-error" role="alert">יש להזין מספר טלפון תקין, לדוגמה 050-000-0000</p>
          }
          @if (otpError) {
            <p class="lm-error" role="alert">{{ otpError }}</p>
          }
        </form>
        <label class="lm-optin">
          <input type="checkbox" [checked]="acceptMarketing"
            (change)="acceptMarketing = $any($event.target).checked" />
          <span>אשמח לקבל עדכונים ומבצעים מ-Sale4All (לא חובה)</span>
        </label>
        <div class="lm-assurance">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 3l7 3v5c0 4.6-2.8 8.1-7 10-4.2-1.9-7-5.4-7-10V6l7-3z" stroke="currentColor" stroke-width="1.8"/>
            <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>הקוד חד-פעמי. לא נשתף את המספר שלכם.</span>
        </div>
        <div class="lm-or"><span>או</span></div>
        <app-google-auth-button (loginSuccess)="completeLogin()"></app-google-auth-button>
        <p class="lm-terms">
          בהמשך הפעולה אתם מאשרים את <a href="/terms" target="_blank" rel="noopener">תנאי השימוש</a> ואת <a href="/privacy" target="_blank" rel="noopener">מדיניות הפרטיות</a>
        </p>
      }

      <!-- ── STEP 2 : OTP ── -->
      @if (otpSent) {
        <div class="lm-progress" aria-label="שלב 2 מתוך 2">
          <span class="lm-progress-label">שלב 2 מתוך 2</span>
          <span class="lm-progress-track lm-progress-track--complete" aria-hidden="true"><span></span></span>
        </div>
        <div class="lm-otp-icon">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="1.8">
            <rect x="5" y="2" width="14" height="20" rx="2.5"/>
            <circle cx="12" cy="17" r="1" fill="#2563eb"/>
          </svg>
        </div>
        <p class="lm-eyebrow">עוד רגע נכנסים</p>
        <h2 id="login-modal-title" class="lm-h">הזינו את קוד האימות</h2>
        <p id="login-modal-description" class="lm-p">שלחנו קוד בן 6 ספרות למספר <strong dir="ltr">{{ phoneNumberDisplay }}</strong></p>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="lm-boxes" dir="ltr">
            <input #b1 class="lm-box" type="text" inputmode="numeric" maxlength="1" aria-label="ספרה 1 מתוך 6" autocomplete="one-time-code"
              (input)="otpAdvance($event,b2)" (keydown)="otpBack($event,null)"
              (paste)="otpPaste($event,[b1,b2,b3,b4,b5,b6])"/>
            <input #b2 class="lm-box" type="text" inputmode="numeric" maxlength="1" aria-label="ספרה 2 מתוך 6"
              (input)="otpAdvance($event,b3)" (keydown)="otpBack($event,b1)"/>
            <input #b3 class="lm-box" type="text" inputmode="numeric" maxlength="1" aria-label="ספרה 3 מתוך 6"
              (input)="otpAdvance($event,b4)" (keydown)="otpBack($event,b2)"/>
            <input #b4 class="lm-box" type="text" inputmode="numeric" maxlength="1" aria-label="ספרה 4 מתוך 6"
              (input)="otpAdvance($event,b5)" (keydown)="otpBack($event,b3)"/>
            <input #b5 class="lm-box" type="text" inputmode="numeric" maxlength="1" aria-label="ספרה 5 מתוך 6"
              (input)="otpAdvance($event,b6)" (keydown)="otpBack($event,b4)"/>
            <input #b6 class="lm-box" type="text" inputmode="numeric" maxlength="1" aria-label="ספרה 6 מתוך 6"
              (input)="otpCollect([b1,b2,b3,b4,b5,b6])" (keydown)="otpBack($event,b5)"/>
          </div>
          @if (otpInfo) {
            <p class="lm-info" role="status">{{ otpInfo }}</p>
          }
          @if (otpError) {
            <p class="lm-error" role="alert">{{ otpError }}</p>
          }
          <button class="lm-btn" type="submit" [disabled]="loginForm.get('otp')?.value?.length !== 6 || sending">אימות וכניסה</button>
        </form>
        <div class="lm-footer-row">
          <button class="lm-ghost" type="button" [disabled]="resendLeft > 0 || sending" (click)="sendOtp()">
            @if (resendLeft > 0) {
              שליחת קוד חדש בעוד <span dir="ltr">{{ resendLabel }}</span>
            } @else {
              שליחת קוד חדש
            }
          </button>
          <span class="lm-dot">·</span>
          <button class="lm-ghost" type="button" (click)="changePhone()">שינוי מספר הטלפון</button>
        </div>
      }

  </section>
</ng-template>
